module.exports = __webpack_public_path__ + "img/bb-logo-icon.5cd9c975.svg";